module.exports = __webpack_public_path__ + "static/img/banner_01.4d42e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/about/banner_01.png
// module id = nT0F
// module chunks = 6